export default {
    "login": {
        "text_modal_title": "Customer Service Platform",
        "phd_account": "Email or Phone",
        "phd_password": "Password",
        "text_btn_login": "Login",
        "link_forget_pwd": "Forgot Password",
        "login": "Login Success",
        "account_not_filled": "Please fill in your Email or Phone",
        "password_not_filled": "Please fill in your Password",
        "account_password_error": "Incorrect Login or Password",
        "text_btn_reg": "Register"
    },
    "reg": {
        "text_ipt_email": "Email",
        "text_ipt_email_vcode": "Email verification code",
        "text_btn_vcode": "Get",
        "text_ipt_phone": "Phone",
        "text_ipt_pwd": "Password",
        "text_btn_login": "Login",
        "text_ipt_pwd_confirm": "Confirm Password",
        "text_btn_reg": "Register",
        "text_reg_succ": "Register Success",
        "email_not_filled": "Please fill in your Email",
        "email_vcode_not_filled": "Please fill in the email Vcode",
        "phone_not_filled": "Please fill in your Phone",
        "password_not_filled": "Please fill in your Password",
        "password_confirm_not_filled": "Please fill in your Confirm Password",
        "password_not_same": "Both Passwords are not consistent",
        "reg_failed": "Register Failed"
    },
    "forget_pwd": {
        "text_forgetpwd_modal_title": "Forget Password",
        "text_ipt_email": "Email",
        "btn_forgetpwd": "Send Email to Reset Password",
        "text_btn_login": "Login",
        "noti_sent": "Sent, please check your email",
        "email_not_filled": "Please fill in your Email",
        "error_sent_failed": "Failed to send"
    },
    "reset_pwd": {
        "text_ipt_pwd": "Password",
        "text_ipt_pwd_confirm": "Confirm Password",
        "password_not_filled": "Please fill in your Password",
        "password_confirm_not_filled": "Please fill in your Confirm Password",
        "password_not_same": "Both Passwords are not consistent",
        "text_resetpwd_modal_title": "Reset Password",
        "btn_resetpwd": "Confirm Password",
        "noti_reset_succ": "Password Reset Success",
        "error_reset_failed": "Password Reset Failed"
    },
    "sidebar": {
        "text_modal_title": "Customer Service Platform",
        "account": "Account",
        "company": "Company",
        "homepage": "Self-service Platform Main",
        "service_account": "Service Account",
        "account_brief": "All Accounts",
        "account_enquiry": "Account Enquiry",
        "account_service": "Account Service",
        "e_card": "E-card",
        "file_inform": "Document Notification",
        "bill_and_renew": "Bill and Renewal",
        "delegate_permission": "Delegate Access",
        "personal_account": "Personal Account",
        "wallet": "Wallet",
        "request_a_service": "Apply Service",
        "manual": "Manual",
        "suggestion_and_enquiry": "User Suggestion/Enquiry",
        "logout": "Logout Sccuess",
        "tab_user_management": "User Management",
        "tab_service_management": "Service Management",
        "tab_service_management_services": 'Package Management',
        "tab_service_management_credits": 'Credit Management',
        "tab_service_management_hk": "Hong Kong Company",
        "tab_service_management_hk_l": "Company Limited",
        "tab_service_management_hk_Ul": "Unlimited Company",
        "tab_service_management_os": "Hong Kong Offshore Company",
        "tab_service_management_os_bvi": "BVI",
        "tab_service_management_os_cayman": "Cayman",
        "tab_service_management_os_seychelles": "Seychelles",
        "tab_service_management_so": "Serviced Office",
        "tab_service_management_vo": "Virtual Office",
        "tab_service_management_cs": "Company Secretarial Services",
        "tab_service_management_as": "Accounting Services",
        "tab_service_management_as_proxy": "Accounting Tax Return",
        "tab_service_management_as_tax": "Accounting Agency",
        "tab_service_management_val_added": "Top-up Value Service",
        "tab_service_management_val_added_be": "Business Email",
        "tab_service_management_val_added_bnc": "Name Card Printing",
        "tab_service_management_val_added_csl": "Company Seal",
        "tab_service_management_val_added_tr": "Trademark Agency Service",
        "tab_service_management_val_added_bar": "Bank Account Agency Service",
        "tab_individual": "Personal Account",
        "tab_apply_form": "Service Management",
        "tab_apply_form_hk": "Hong Kong Company",
        "tab_apply_form_hk_l": "Company Limited",
        "tab_apply_form_hk_ul": "Unlimited Company",
        "tab_apply_form_os": "Hong Kong Offshore Company",
        "tab_apply_form_os_bvi": "BVI",
        "tab_apply_form_os_cayman": "Cayman",
        "tab_apply_form_os_seychelles": "Seychelles",
        "tab_apply_form_so": "Serviced Office",
        "tab_apply_form_vo": "Virtual Office",
        "tab_apply_form_cs": "Company Secretarial Services(Coming Soon)",
        "tab_apply_form_as": "Accounting Services",
        "tab_apply_form_as_proxy": "Accounting Tax Return",
        "tab_apply_form_as_tax": "\"Accounting Agency",
        // "tab_apply_form_as": "Accounting Services(Coming Soon)",
        // "tab_apply_form_as_proxy": "Accounting Tax Return(Coming Soon)",
        // "tab_apply_form_as_tax": "\"Accounting Agency(Coming Soon)",
        "tab_apply_form_val_added": "Top-up Value Service",
        "tab_apply_form_val_added_be": "Business Email",
        "tab_apply_form_val_added_bnc": "Name Card Printing",
        "tab_apply_form_val_added_csl": "Company Seal",
        "tab_apply_form_val_added_tr": "Trademark Agency Service",
        "tab_apply_form_val_added_bar": "Bank Account Agency Service",
        "text_tips_i18n": 'refresh page when changed lang'
    },
    "individual": {
        "col_label_name": "Company Name",
        "col_label_name_cn": "Company Name Cn",
        "col_label_applier": "Applicant",
        "col_label_package": "Package/Service",
        "col_label_updatedat": "Updated Time",
        "col_label_status": "Status",
        "col_label_operation": "Operation",
        "noti_sent_recp_succ": "Sent Receipt Sccuess",
        "error_sent_recp_failed": "Sending Receipt Failed",
        "noti_sent_inv_succ": "Sent Invoice Success",
        "error_sent_inv_failed": "Sending Invoice Failed",
        "label_detail": "Details",
        "label_invoice": "Invoice",
        "label_receipt": "Receipt",
        "label_hello": "Hi",
        "label_current_credit": "Current Credit:",
        "label_value_added": "Top-up Value",
        "label_added_record": "Top-up Value Record",
        "label_send_recp": "Sent Receipt",
        "label_recp_annual": "Annual Year",
        "label_recp_annual_start": "Issue Date",
        "label_recp_annual_end": "Expiry Date",
        "label_confirm": "Confirm",
        "label_cancel": "Cancel"
    },
    "upload_button": {
        "label_upload": "Upload Document",
        "noti_uploaded_succ": "Upload Success",
        "error_uploaded_failed": "Upload Failed"
    },
    "preview_router_form": {
        "form_title_1": "Contact Information",
        "form_title_2": "Selected Service Plan",
        "form_title_3": "Establishment/Purchase of Ready-made Limited Company Information",
        "form_title_4": "Issued Capital",
        "form_title_5": "Please select the number of directors and founding members",
        "form_title_6": "Value-added Services",
        "label_form_name": "*Name:",
        "label_form_title": "*Title:",
        "label_form_phone": "*Phone:",
        "label_form_email": "*Email:",
        "label_form_address": "Address:",
        "label_form_contact_way": "How would you like us to contact you:",
        "label_form_contact_slot": "What time would you like us to contact you:",
        "label_form_com_en_name": "Company's English Name:",
        "label_form_com_cn_name": "Company's Chinese Name:",
        "label_form_com_addr": "*Company's Correspondence Address(If the package includes a virtual address service, this item will default to a virtual address):",
        "label_form_com_addr_use_default": "*Use the default alliance address as the registered address:",
        "label_form_com_addr_reg": "*Registered Address:",
        "label_form_preset_shares": "*The default registered capital is 1 Hong Kong dollar, divided into 1 share, with a par value of 1 Hong Kong dollar per share:",
        "label_form_preset_shares_en": "*The default registered capital is 1 US dollar, divided into 1 share, with a par value of 1 US dollar per share:",
        "label_form_is_num": "Number of Shares Issued:",
        "label_form_val": "Par Value per Share (HKD):",
        "label_form_val_en": "Par Value per Share (USD):",
        "label_form_val_total": "Total Par Value (HKD):",
        "label_form_val_total_en": "Total Par Value (USD):",
        "label_form_bus_nature": "*Nature of Business:",
        "label_form_bus_region": "*Region of Business:",
        "label_form_board_num": "Please select the number of directors and founding members:",
        "label_form_value_added": "Value-added Services:",
        "label_form_uploaded_file": "Upload File:",
        "label_form_board_no_before": "*The",
        "label_form_board_no_after": "th shareholder:",
        "label_form_board_identity": "*Identity:",
        "label_form_board_holding": "Number of Shares Held:",
        "label_form_board_sh_en_name": "Name of the Shareholder/Director in English:",
        "label_form_board_sh_cn_name": "Name of the Shareholder/Director in Chinese:",
        "label_form_board_sh_phone": "*Phone:",
        "label_form_board_sh_email": "*Email:",
        "label_form_board_sh_address_before": "*Address (The",
        "label_form_board_sh_address_after": "th shareholder/director):",
        "label_form_board_sh_id_before": "*ID Card/Passport (The",
        "label_form_board_sh_id_after": "th shareholder/director):",
        "label_form_board_sh_ic_before": "*Issuing Country (The",
        "label_form_board_ic_after": "th shareholder/director):",
        "label_form_board_com_reg_addr": "*Registered Address of the Company (If the identity is a company):",
        "label_form_board_com_reg_num": "*Company Registration Number (If the identity is a company):",
        "label_form_board_com_reg_bus_num": "*Business Registration Certificate Number (If the identity is a company):",
        "label_form_board_com_reg_c": "*Country of Registration (If the identity is a company):",
        "label_form_board_com_fund_source": "Detailed source of funds (If the identity is a company)",
        "label_form_board_com_fund_source_before": "Detailed source of funds (The",
        "label_form_board_com_fund_source_after": "th shareholder/director)",
        "noti_form_edit_succ": "Changes saved successfully",
        "error_form_edit_failed": "Failed to save changes",
        "label_form_edit": "Edit",
        "label_form_confirm": "Confirm",
        "label_form_cancel": "Cancel",
        "label_form_title_male": "Mr.",
        "label_form_title_female": "Ms.",
        "label_form_contact_way_wts": "WhatsApp",
        "label_form_contact_way_phone": "Phone",
        "label_form_contact_way_email": "Email",
        "label_form_contact_way_wechat": "WeChat",
        "label_form_contact_way_wechat_no": "Your WeChat",
        "label_form_contact_slot_912": "9am - 12pm",
        "label_form_contact_slot_23": "2pm - 3pm",
        "label_form_contact_slot_35": "3pm - 5:30pm",
        "label_form_preset_shares_yes": "Yes",
        "label_form_preset_shares_no": "No",
        "label_form_com_addr_use_default_yes": "Yes",
        "label_form_com_addr_use_default_no": "No",
        "label_form_board_num_new": "New",
        "label_form_value_added_be": "Corporate Email(Get Quotation)",
        "label_form_value_added_cp": "Business Card Printing",
        "label_form_value_added_cp_1": "Print 100 Business Cards",
        "label_form_value_added_cp_2": "Print 200 Business Cards",
        "label_form_value_added_cs": "Customized Seal",
        "label_form_value_added_cs_1": "Authorized Signature",
        "label_form_value_added_cs_2": "Company Chop",
        "label_form_value_added_ba": "Apply for Bank Account(Get Quotation)",
        "label_form_value_added_tm": "Register Trademark(Get Quotation)",
        "label_form_value_added_cse": "Company Secretary",
        "label_form_previous": "Previous",
        "label_form_next": "Next",
        "label_form_preview": "Preview",
        "label_form_submit": "Submit",
        "error_form_fill_form": "Please fill in the information completely",
        "noti_form_submit_succ": "Submitted successfully",
        "error_form_submit_failed": "Submission failed",
        "label_form_board_indentity_personal": "Individual",
        "label_form_board_indentity_company": "Company",
        "label_form_board_indentity_director": "Director",
        "label_form_board_indentity_shareholder": "Shareholder",
        "col_label_name": "Company Name",
        "col_label_name_cn": "Chinese Company Name",
        "col_label_applier": "Applicant",
        "col_label_package": "Package/Service",
        "col_label_amount": "Amount",
        "col_label_updatedat": "Updated Time",
        "col_label_status": "Status",
        "col_label_operation": "Operation",
        "label_export_as": "Export as",
        "label_export_as_csv": "CSV",
        "label_export_as_pdf": "PDF",
        "noti_msg_delete": "Once deleted, it cannot be recovered, are you sure?",
        "label_delete": "Delete",
        "label_export_file_format": "Account Overview.pdf",
        "label_form_table_title": "Account Overview",
        "label_form_pig_singular": "Item",
        "label_form_pig_plural": "Items",
        "label_form_pig_message": "Selected",
        "label_form_pig_rows_per_page": "Per page:",
        "label_form_pig_select_all": "All",
        "col_label_user_name": "Username",
        "col_label_user_phone": "Phone",
        "col_label_user_email": "Email",
        "col_label_user_title": "Title",
        "noti_delete_succ": "Delete successful",
        "error_delete_failed": "Delete failed",
        "noti_update_succ": "Update successful",
        "error_update_failed": "Update failed",
        "label_profile_title": "Edit Personal Information",
        "col_label_user_enquiry_type": "Inquiry Type",
        "noti_reply_succ": "Replied",
        "error_reply_failed": "Reply failed",
        "label_reply_phd": "Please fill in the reply email",
        "label_reply": "Reply",
        "label_search_component_type": "Type",
        "noti_create_succ": "Create successful",
        "error_create_failed": "Create failed",
        "label_create": "Create",
        "label_cancel": "Cancel",
        "label_no_data_show": "No data is currently displayed",
        "col_package_name": "Package",
        "col_package_price": "Price",
        "col_package_content_tc": "Traditional Chinese Content",
        "col_package_content_cn": "Simplified Chinese Content",
        "col_package_content_en": "English Content",
        "col_package_discount": "Discount",
        "col_package_discount_start": "Discount Start Time",
        "col_package_discount_end": "Discount End Time",
        "form_title_vo_1": "Fill in Company Information",
        "form_title_vo_2": "Virtual Office Contact",
        "form_title_vo_3": "Value-added Services",
        "form_title_vo_4": "Completion and End",
        "form_title_vo_col_identity": "Select Application Identity",
        "form_title_vo_col_identity_com": "Hong Kong Company/Unlimited Company/Other",
        "form_title_vo_col_identity_ind": "Individual",
        "form_title_vo_col_identity_org": "Organization",
        "form_title_vo_col_bus_reg_license": "Business Registration Certificate",
        "form_title_vo_col_bus_reg_license_yes": "Yes",
        "form_title_vo_col_bus_reg_license_no": "No",
        "form_title_vo_col_reg_date": "Registration Date",
        "form_title_vo_col_bus_reg_num": "Business Registration Number",
        "form_title_vo_col_need_upload_file": "Documents Required to Upload (Additional documents can be submitted at 'Personal Account -> Application Record -> Upload Document')",
        "form_title_vo_col_file_bug_reg_copy": "1. Business Registration Certificate Copy (If there is a company registration certificate copy)",
        "form_title_vo_col_main_contact": "Main Contact (At least one, can be multiple)",
        "form_title_vo_col_main_contact_identity": "Contact Identity",
        "form_title_vo_col_main_contact_identity_director": "Director",
        "form_title_vo_col_main_contact_identity_sh": "Shareholder",
        "form_title_vo_col_main_contact_identity_secretary": "Company Secretary",
        "form_title_vo_col_main_contact_identity_staff": "Staff",
        "form_title_vo_col_main_contact_identity_agent": "Agent",
        "form_title_vo_col_main_contact_title": "Title",
        "form_title_vo_col_main_contact_title_mr": "Mr.",
        "form_title_vo_col_main_contact_title_miss": "Miss",
        "form_title_vo_col_main_contact_title_mrs": "Mrs.",
        "form_title_vo_col_main_contact_name_en": "English Name",
        "form_title_vo_col_main_contact_name_cn": "Chinese Name",
        "form_title_vo_col_main_contact_phone": "Contact Phone",
        "form_title_vo_col_main_contact_email": "Contact Email",
        "form_title_vo_col_main_contact_address": "Mailing Address",
        "form_title_vo_col_main_contact_birthday": "Date of Birth",
        "form_title_vo_col_main_contact_identity_verify": "Identity Verification",
        "form_title_vo_col_main_contact_identity_verify_gotobank": "1. Visit Branch in Person",
        "form_title_vo_col_main_contact_identity_verify_online": "2. Video Conference",
        "form_title_vo_col_main_contact_file_hkid_copy": "1. Contact's ID Document",
        "form_title_vo_confirm": "Confirm and Submit Application",
        "form_title_vo_tac_com_1": "1. I understand that I must return the signed documents within 12 days or as guided by the customer service officer to complete the relevant procedures, otherwise I will bear the penalties or consequences arising therefrom. I also understand that if I do not submit sufficient documents to complete the application service within one month, it will be considered as giving up the service, I will not be refunded, and I will be charged again for continued service.",
        "form_title_vo_tac_com_2": "2. I confirm that this is not a listed company, and I understand that if I falsely report, the service will be terminated immediately.",
        "form_title_vo_tac_com_3": "3. I confirm that the information filled in above is accurate and error-free, and I have read and agreed to the Virtual Office Service Terms. I agree to be responsible for any problems or administrative fees arising from the above information errors.",
        "form_title_vo_tac_tips": "*Submitting the form means you agree to the above terms",
        "form_title_vo_col_ind_file_address_copy": "1. Address Proof Copy",
        "form_vo_col_reg_country": "Country of Registration",
        "form_vo_col_org_num": "Organization Number",
        "form_title_vo_col_org_file_org_copy": "1. Organization Proof Copy",
        "form_title_vo_tac_ind_1": "1. I understand that I must return the signed documents within 12 days or as guided by the customer service officer to complete the relevant procedures, otherwise I will bear the penalties or consequences arising therefrom. I also understand that if I do not submit sufficient documents to complete the application service within one month, it will be considered as giving up the service, I will not be refunded, and I will be charged again for continued service.",
        "form_title_vo_tac_ind_2": "2. I confirm that the information filled in above is accurate and error-free, and I have read and agreed to the Virtual Office Service Terms. I agree to be responsible for any problems or administrative fees arising from the above information errors.",
        "form_title_vo_tac_org_1": "1. I understand that I must return the signed documents within 12 days or as guided by the customer service officer to complete the relevant procedures, otherwise I will bear the penalties or consequences arising therefrom. I also understand that if I do not submit sufficient documents to complete the application service within one month, it will be considered as giving up the service, I will not be refunded, and I will be charged again for continued service.",
        "form_title_vo_tac_org_2": "2. I confirm that the information filled in above is accurate and error-free, and I have read and agreed to the Virtual Office Service Terms. I agree to be responsible for any problems or administrative fees arising from the above information errors.",
        "form_cs_file_com_reg": "2. Company Registration Certificate",
        "form_cs_file_com_policy": "3. Company Articles of Association",
        "form_cs_file_director_list": "4. Register of Directors",
        "form_cs_file_sh_list": "5. Register of Shareholders",
        "form_cs_file_main_ctr_list": "6. Register of Persons with Significant Control",
        "form_cs_file_nar1_last_year": "- NAR1 form submitted last year",
        "form_cs_file_nar1_updated_last_year": "- Were there any other change documents or transfer documents submitted after the NAR1 last year (all need to be uploaded if any)",
        "form_cs_file_director_sh_id": "1. Identity card/passport/travel certificate copy",
        "form_cs_file_director_address_verify": "2. Address proof",
        "form_title_cs_1": "Company Information",
        "form_title_cs_2": "Director/Shareholder Information",
        "form_title_cs_3": "Secretary Company (if not our company)",
        "form_cs_col_sh_holding": "Number of Shares Held",
        "form_cs_col_sc_com": "Secretary Company (if not our company)",
        "form_cs_col_sc_title": "Title",
        "form_cs_col_sc_name_cn": "Chinese Name",
        "form_cs_col_sc_name_en": "English Name",
        "form_cs_col_sc_phone": "Contact Phone",
        "form_cs_col_sc_email": "Contact Email",
        "form_cs_col_sc_addr": "Correspondence Address",
        "form_ex_cp_title_1": "Contact Information",
        "form_ex_cp_title_2": "Data to be provided on business cards",
        "form_ex_cp_col_isbilinguish": "Select card language",
        "form_ex_cp_col_isbilinguish_cn": "Chinese",
        "form_ex_cp_col_isbilinguish_en": "English",
        "form_ex_cp_col_isbilinguish_other": "Other",
        "form_ex_cp_col_position_cn": "Chinese Position",
        "form_ex_cp_col_position_en": "English Position",
        "form_ex_cp_col_addr_cn": "Chinese Contact Address",
        "form_ex_cp_col_addr_en": "English Contact Address",
        "form_ex_cp_col_other": "Note",
        "form_ex_cp_col_c_phone": "Contact Phone",
        "form_ex_cp_col_c_email": "Contact Email",
        "form_ex_cs_title_1": "Company Name in English and Chinese on the Seal",
        "form_ex_rb_title_1": "Fill in Trademark Information",
        "form_ex_rb_tm_reg": "Trademark Registration Location",
        "form_ex_rb_tm_holder": "Trademark Owner's Name",
        "form_ex_rb_tm_holder_addr": "Trademark Owner's Correspondence Address",
        "form_ex_rb_tm_holder_id": "Personal Identification Document (if the trademark owner is an individual, upload is required)",
        "form_ex_rb_tm_holder_bus": "Business Registration Certificate (if the trademark owner is a company, upload is required)",
        "form_ex_rb_tm_holder_reg": "Company Registration Certificate (if the trademark owner is a company, upload is required)",
        "form_ex_rb_tm_holder_dir": "Information of any Director (if the trademark owner is a company, upload is required)",
        "form_ex_rb_tm_icon": "Trademark Design to be Registered",
        "form_ex_rb_tm_type": "Category of the Trademark to be Registered",
        "form_ex_rb_tm_desc": "Detailed Description of the Trademark to be Registered",
        "form_credit_total": "Total Credits",
        "form_credit_add_to": "Add Value To This Account",
        "label_confirm": "Confirm",
    }
    ,
    "payment": {
        "label_pay": "Pay",
        "label_val_added": "Top-up Value",
        "label_return_indi": "Return to Personal Account",
        "label_payment_succ": "Payment Success",
        "label_payment_failed": "Payment Failed",
        "label_payment_cancel": "Payment Cancel"
    },
    "suggestion": {
        "error_sug_not_filled": "Please fill in complete information",
        "noti_sug_sent_succ": "Submit Success",
        "error_sug_sent_failed": "Submit Failed",
        "label_sug_enquiry_type": "Enquiry Type",
        "label_sug_name": "Name",
        "label_sug_email": "Email",
        "label_sug_phone": "Phone",
        "label_sug_msg": "Content",
        "label_sug_send": "Submit"
    },
    "wallet": {
        "col_applier": "Applicant",
        "col_amount": "Amount",
        "col_updated_at": "Update Time",
        "col_status": "Status",
        "error_val_added_failed": "Top-up Value Failed",
        "label_wallet_current_credit": "Current Credit Value: ",
        "label_wallet_other_payments": "Other value-added methods (please contact the administrator after successful payment):",
        "value_100": "100HKD",
        "value_200": "200HKD",
        "value_500": "500HKD",
        "value_1000": "1000HKD",
        "value_2000": "2000HKD",
        "value_3000": "3000HKD",
        "btn_val_added": "Top-up",
        "label_past_record": "Past Top-up Value Record"
    },
    "reply_selection": {
        "label_reply_type_hkr": 'Register a Hong Kong Company',
        "label_reply_type_osr": 'Register an overseas company',
        "label_reply_type_as": 'accounting services',
        "label_reply_type_cs": 'Company secretary',
        "label_reply_type_so": 'serviced office',
        "label_reply_type_vo": 'virtual office',
        "label_reply_type_va": 'Value-added services',
    }
}